import { ICareItem, ICareStatus, ICareType } from '../types'

// Gera array de datas: hoje, amanhã e mais 5 datas aleatórias nos próximos 10 dias
const today = new Date()
const tomorrow = new Date()
tomorrow.setDate(today.getDate() + 1)
const randomDates = [today, tomorrow]
for (let i = 0; i < 5; i++) {
  const d = new Date()
  d.setDate(today.getDate() + Math.floor(Math.random() * 10) + 2)
  randomDates.push(d)
}
const dateStrs = randomDates.map(d => d.toISOString())

export const mockCareItems = (length: number): ICareItem[] => {
  const types: ICareType[] = [ICareType.APPOINTMENT, ICareType.EXAM]
  const examNames = [
    'Hemograma',
    'USG abdome total',
    'Raio-X de tórax',
    'Eletrocardiograma',
    'Glicemia',
    'Colesterol total',
    'Urina tipo 1',
    'TSH',
    'Triglicerídeos',
    'Creatinina',
    'Vitamina D',
    'PCR',
    'D-dímero',
    'Beta HCG',
    'Teste ergométrico',
  ]
  const forwardingTitles = [
    'Encaminhamento para Cardiologia',
    'Encaminhamento para Psicologia',
    'Encaminhamento para Ortopedia',
    'Encaminhamento para Dermatologia',
    'Encaminhamento para Endocrinologia',
    'Encaminhamento para Oftalmologia',
    'Encaminhamento para Ginecologia',
    'Encaminhamento para Neurologia',
  ]
  const examStatuses = [
    ICareStatus.TO_REALIZE,
    ICareStatus.LATE,
    ICareStatus.ORDERED,
    ICareStatus.RESULT_DONE,
    // ICareStatus.PAUSED,
  ]
  const appointmentStatuses = [
    ICareStatus.TO_REALIZE,
    ICareStatus.LATE,
    ICareStatus.SCHEDULED,
    // ICareStatus.CONFIRMED,
    ICareStatus.REALIZED,
    ICareStatus.CANCELLED,
    // ICareStatus.PAUSED,
  ]

  const appointmentTitles = [
    'Consulta de cardiologia',
    'Consulta de urologia',
    'Consulta de clínica geral',
    'Consulta de dermatologia',
  ]

  return Array.from({ length }, (_, i) => {
    const type = types[Math.floor(Math.random() * 2)]
    const randomDate = dateStrs[Math.floor(Math.random() * dateStrs.length)]

    if (type === ICareType.FORWARDING) {
      const startDate = new Date(2021, 0, (i % 28) + 1).toISOString()
      return {
        id: `${i + 1}`,
        type,
        status: ICareStatus.NOT_SCHEDULED,
        title: forwardingTitles[i % forwardingTitles.length],
        frequencyTime: 'month',
        frequencyValue: 0,
        statusTimeInDays: 2,
        forwarding: {
          id: `${i + 1}`,
          startDate,
          appointmentSuggestion: {
            fromProfessionalName: `Profissional ${i + 1}`,
            professional: {
              id: `${i + 1}`,
              name: `Profissional ${i + 1}`,
              specialtyId: `spec${i + 1}`,
              specialtyName: 'Clínico Geral',
              photo: 'https://mdbcdn.b-cdn.net/img/new/avatars/2.webp',
              councilType: 'CRM',
              professionalTypeId: '1',
            },
          },
        },
      }
    }

    if (type === ICareType.EXAM) {
      const status = examStatuses[i % examStatuses.length]
      const isOrdered = status === ICareStatus.ORDERED
      const omitOriginAppointment = isOrdered && Math.random() < 0.5
      const canSchedule = Math.random() < 0.5

      return {
        id: `${i + 1}`,
        type,
        status,
        title: examNames[i % examNames.length],
        frequencyTime: 'month',
        frequencyValue: 1,
        statusTimeInDays: 2,
        exam: {
          canSchedule,
          details: 'Detalhes da prescrição',
          ...(omitOriginAppointment
            ? {}
            : {
                originAppointment: {
                  id: `${i + 1}`,
                  professional: {
                    id: `${i + 1}`,
                    name: `Profissional ${i + 1}`,
                    specialtyId: `spec${i + 1}`,
                    specialtyName: 'Clínico Geral',
                    photo: 'https://mdbcdn.b-cdn.net/img/new/avatars/2.webp',
                    councilType: 'CRM',
                    professionalTypeId: '1',
                  },
                  startDate: randomDate,
                },
              }),
        },
      }
    }

    // type === 'appointment'
    const appointmentStatus =
      Math.random() < 0.5
        ? ICareStatus.SCHEDULED
        : appointmentStatuses[i % appointmentStatuses.length]
    const hasAppointment =
      appointmentStatus !== ICareStatus.CONFIRMED && Math.random() < 0.5

    return {
      id: `${i + 1}`,
      type,
      status: appointmentStatus,
      title: appointmentTitles[i % appointmentTitles.length],
      frequencyTime: 'month',
      frequencyValue: 1,
      statusTimeInDays: -2,
      ...(hasAppointment && {
        appointment: {
          id: `${i + 1}`,
          attendanceToken: `token-${i + 1}`,
          professional: {
            id: `${i + 1}`,
            name: `Profissional ${i + 1}`,
            specialtyId: `spec${i + 1}`,
            specialtyName: 'Clínico Geral',
            photo: 'https://mdbcdn.b-cdn.net/img/new/avatars/2.webp',
            councilType: 'CRM',
            professionalTypeId: '1',
          },
          startDate: randomDate,
        },
      }),
    }
  })
}
